<template>
    <CRow>
        <CCol col>
            <div style="width:100%; height: 80vh;">
                <ejs-grid ref='grid' :dataSource="otherMarketPricingDataLogs" :allowFiltering='true' :allowPaging="true" :allowResizing='true'
                          :toolbarClick='toolbarClick' :allowExcelExport='true' :excelExportComplete='excelExportComplete'
                          :allowReordering='true' :allowSorting='true' :toolbar='toolbar' :actionBegin="actionBegin"
                          :pageSettings='pageSettings' :actionComplete='actionComplete' :excelQueryCellInfo='excelQueryCellInfo'
                          :actionFailure="actionFailure" :filterSettings='filterOptions' width="100%" height="100%" :queryCellInfo='queryCellInfo'>
                    <e-columns>
                        <e-column field='otherInstrumentLogId' headerText='Id' width=120 :isPrimaryKey='true' :visible='false'></e-column>
                        <e-column field='otherInstrumentId' headerText='Other Instrument Id' width=120></e-column>
                        <e-column field='ricName' headerText='Identifier' textAlign='Left' width=120></e-column>
                        <e-column field='description' headerText='Description' textAlign='Left' width=300></e-column>
                        <e-column field='utilityTypeName' headerText='Category' textAlign='Left' width=150></e-column>
                        <e-column field='periodTypeName' headerText='Period Type' textAlign='Left' width=150></e-column>
                        <e-column field='periodCodeType' headerText='Period Code' type="number" textAlign='Left' width=150></e-column>
                        <e-column field='universalClosePriceDate' headerText='Settlement Date' :format='dateFormatOptions' textAlign='Left' width=180></e-column>
                        <e-column field='price' headerText='Settlement Price' type="number" format="n3" textAlign='Left' width=180></e-column>
                        <e-column field='tradingUnitPreview' headerText='Trading Unit' textAlign='Left' width=150></e-column>
                        <e-column field='date' headerText='Import Date' :format='dateFormatOptions' textAlign='Left' width=150></e-column>
                        <e-column field='logDate' headerText='Log Date' textAlign='Left' width=190 type="date" :format='dateFormatOptions'></e-column>
                        <e-column field='logTime' headerText='Log Time' textAlign='Left' type='string' width=150></e-column>
                        <e-column field='userName' headerText='User' textAlign='Left' width=150 type="string"></e-column>
                    </e-columns>
                </ejs-grid>
            </div>
        </CCol>
    </CRow>
</template>

<script>
    import Vue from 'vue';
    import { GridPlugin, Toolbar, Page, Filter, Sort, Reorder, Resize, ExcelExport, ForeignKey } from '@syncfusion/ej2-vue-grids';
    import { Query } from '@syncfusion/ej2-data';
    import authToken from '../../common/authToken';
    import store from '../../store';
    import dates from '../../common/dates';
    import gridOptions from '../../common/gridOptions';
    import SyncHelper from '../../common/syncfusion';
    import { createSpinner, hideSpinner, showSpinner } from '@syncfusion/ej2-popups';

    Vue.use(GridPlugin);

    export default {
        components: {
        },
        data() {
            return {
                store: store,
                otherMarketPricingDataLogs: SyncHelper.getDataManager('otherMarketInstrumentsLogs'),
                toolbar: ['ExcelExport'],
                pageSettings: gridOptions.pageSettings,
                filterOptions: gridOptions.filterSettings,
                dateFormatOptions: { type: 'date', format: 'dd/MM/yyyy', max: new Date(), params: { max: new Date() } },
            };
        },
        mounted() {
            createSpinner({
                target: document.getElementById('mainSpinner'),
                width: '50',
                type: 'Material',
                label: 'Loading data...',
                cssClass: 'loadingPoup'
            });
        },
        methods: {
            actionComplete: function (args) {
                gridOptions.actionComplete(args, this.$refs);

            },
            actionBegin: function (args) {
                gridOptions.actionBegin(args);
            },
            actionFailure: function (args) {
                gridOptions.actionFailure(args);
            },
            toolbarClick(args) {
                if (args.item.id.includes('excelexport')) {
                    gridOptions.excelExport(args, 'Other Market Instruments Logs.xlsx', this.$refs);
                }
            },
            excelExportComplete(args) {
                this.$refs.grid.hideSpinner();
            },
            addHeaders: function (args) {
                args.currentRequest.SetRequestHeader('Authorization', `Bearer ${authToken.get()}`);

            },
            onFocus: function (args) {
                this.$refs.dateObj.show();
            },
            queryCellInfo(args) {

                if (args.column.field === 'logTime') {
                    args.cell.textContent = this.convertUTCDateToLocalTime(args.data['logTime']);
                }
            },
            convertUTCDateToLocalTime(dateString) {
                const date = new Date(dateString)
                var newDate = new Date(date.getTime() - date.getTimezoneOffset() * 60 * 1000);
                return newDate.toLocaleTimeString();
            },
            excelQueryCellInfo(args) {

                if (args.column.field === 'logTime') {
                    args.value = this.convertUTCDateToLocalTime(args.data['logTime']);
                }
            }
        },

        provide: {
            grid: [Page, Toolbar, Filter, Sort, Resize, Reorder, ExcelExport, ForeignKey]
        }
    };
</script>

<style scoped>
    .omi-price-padding {
        padding-top: 30px;
    }
</style>